/**
* 项目申报申请表
*/
import request from '../request2'
import zcdApplyInfoApi from "@/api/ccjt/zcdApplyInfo";

const ccjtXmsbApplyInfoApi = Object.assign({}, { baseUrl: '/nmgxmsb/ccjtXmsbApplyInfo' })

ccjtXmsbApplyInfoApi.list = function ({ params, page }) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/list/`+page.pageNo+'/'+page.pageSize,
        method: 'post',
        data: params
    })
}

ccjtXmsbApplyInfoApi.detail = function (id) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/detail/`+id,
        method: 'get',
    })
}


ccjtXmsbApplyInfoApi.delete = function (id) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/delete/`+id,
        method: 'delete',
    })
}

ccjtXmsbApplyInfoApi.update = function (data) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/update`,
        method: 'put',
        data
    })
}
ccjtXmsbApplyInfoApi.add = function (data) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/add`,
        method: 'post',
        data:data
    })
}

ccjtXmsbApplyInfoApi.checkForm = function (data) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/checkForm`,
        method: 'post',
        data:data
    })
}

ccjtXmsbApplyInfoApi.completeTask = function (data) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/completeTask`,
        method: 'put',
        data
    })
}
ccjtXmsbApplyInfoApi.startTask = function (productId) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/startTask/${productId}`,
        method: 'post',
        data: {}
    })
}
ccjtXmsbApplyInfoApi.getTaskButton = function (processInstanceId) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/getTaskButton/${processInstanceId}`,
        method: 'post',
        data: {}
    })
}

ccjtXmsbApplyInfoApi.openDetail = function (id) {
    return request({
        url: `/nmgxmsb/ccjtXmsbApplyInfo/openDetail/`+id,
        method: 'get',
    })
}

export default ccjtXmsbApplyInfoApi
